import React, { useState } from "react";
import ExperienceBrowser from "../components/ExperienceBrowser";
import { cities } from "../data";
import "./BrowseAllPage.css";
import teamwardLogo from "../images/logowithnamewhite.png";


const BrowseAllPage = () => {
  const [selectedCity, setSelectedCity] = useState("All Cities");
  const [search, setSearch] = useState("");

  const cityOptions = cities.includes("All Cities")
    ? cities
    : ["All Cities", ...cities];

  const getCityLabel = (city) => {
    if (city === "Denver") {
      return "Denver, CO";
    }

    if (city === "Casper") {
      return "Casper, WY";
    }

    return city;
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <main className="browse-page">

      {/* =========================================
          HERO
          ========================================= */}
      <section className="browse-hero">
        <div className="browse-hero-inner">

          <div className="browse-hero-copy">
            <div className="browse-hero-eyebrow">
              Explore Team Experiences
            </div>

            <h1>
              Find the right experience
              <br />
              for your team.
            </h1>

            <p className="browse-hero-description">
              Browse curated outings, trainings, speakers, retreats,
              <br className="browse-desktop-break" />
              and volunteer opportunities based on your location,
              <br className="browse-desktop-break" />
              group size, budget, and goals.
            </p>

            {/* SEARCH BAR */}
            <form
              className="browse-hero-search"
              onSubmit={handleSearchSubmit}
            >
              <div className="browse-city-control">
                <span
                  className="browse-control-icon"
                  aria-hidden="true"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
                    <circle cx="12" cy="10" r="2.5" />
                  </svg>
                </span>

                <select
                  value={selectedCity}
                  onChange={(event) =>
                    setSelectedCity(event.target.value)
                  }
                  aria-label="Filter experiences by city"
                >
                  {cityOptions.map((city) => (
                    <option key={city} value={city}>
                      {getCityLabel(city)}
                    </option>
                  ))}
                </select>

                <span
                  className="browse-select-arrow"
                  aria-hidden="true"
                >
                  <svg
                    viewBox="0 0 20 20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 7 5 5 5-5" />
                  </svg>
                </span>
              </div>

              <div className="browse-search-control">
                <span
                  className="browse-control-icon"
                  aria-hidden="true"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <circle cx="11" cy="11" r="7" />
                    <path d="m20 20-4-4" />
                  </svg>
                </span>

                <input
                  type="search"
                  value={search}
                  onChange={(event) =>
                    setSearch(event.target.value)
                  }
                  placeholder="Search vibe, city, or activity"
                  aria-label="Search experiences"
                />
              </div>

              <button
                type="submit"
                className="browse-search-button"
                aria-label="Search experiences"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  aria-hidden="true"
                >
                  <circle cx="11" cy="11" r="7" />
                  <path d="m20 20-4-4" />
                </svg>
              </button>
            </form>
          </div>

   {/* =========================================
    LARGE FAINT TEAMWARD MONOGRAM
    ========================================= */}
<div className="browse-hero-watermark" aria-hidden="true">
  <div className="hero-watermark-crop">
    <img src={teamwardLogo} alt="" />
  </div>
</div>

        </div>
      </section>

      {/* =========================================
          EXPERIENCE RESULTS
          ========================================= */}
      <ExperienceBrowser
        selectedCity={selectedCity}
        search={search}
      />

    </main>
  );
};

export default BrowseAllPage;
